<template>
  <el-row>
    <el-tabs v-model="activeName"
             type="card"
             @tab-click="handleClick">
      <el-tab-pane label="未离开"
                   name="cur"></el-tab-pane>
      <el-tab-pane label="已离开"
                   name="his"></el-tab-pane>
    </el-tabs>

    <el-card shadow="none"
             class="form-card mb-15">
      <el-form :inline="true"
               :model="searchForm"
               ref="search_form"
               class="search-form">
        <el-form-item label="访客姓名:"
                      prop="vist_name">
          <el-input v-model.trim="searchForm.vist_name"
                    placeholder="访客姓名"></el-input>
        </el-form-item>
        <el-form-item label="访客卡号:"
                      prop="med_value">
          <el-input v-model.trim="searchForm.med_value"
                    placeholder="访客卡号">
            <el-button slot="append"
                       @click="readIC()">读卡</el-button>
          </el-input>
          <span v-if="countDown">请读卡{{timer}}</span>
        </el-form-item>
        <el-form-item label="被访人:"
                      prop="vist_name">
          <el-input v-model.trim="searchForm.inter_name"
                    placeholder="被访人姓名"></el-input>
        </el-form-item>
        <el-form-item label="访问部门:"
                      prop="inter_dep_id">
          <el-select v-model="searchForm.inter_dep_id"
                     placeholder="访问部门">
            <el-option v-for="item in depList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="访问区域:"
                      prop="inter_area_id">
          <el-select v-model="searchForm.inter_area_id"
                     placeholder="访问区域">
            <el-option v-for="item in areaList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="来访时段:">
          <el-date-picker v-model="searchForm.begin_time"
                          value-format="yyyy-MM-dd"
                          type="daterange"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     @click="searchSubmit('search_form')">查询
          </el-button>
          <el-button icon="el-icon-refresh"
                     @click="resetForm('search_form')">重置
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-row>
      <el-button v-has="'/visitor/add'"
                 type="primary"
                 @click="openVisitorAdd">新增访客</el-button>
    </el-row>
    <el-card shadow="none"
             class="mt-15">
      <el-table max-height="575"
                ref="multipleTable"
                :data="tableData"
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="50"> </el-table-column>
        <el-table-column v-for="(item, index) in tableTitle"
                         :fixed="item.fixed"
                         :key="index"
                         :label="item.name"
                         :prop="item.prop"
                         :min-width="item.width"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         v-if="activeName === 'cur'"
                         width="120">
          <template slot-scope="scope">
            <el-button v-has="'/visitor/leave'"
                       plain
                       size="mini"
                       type="danger"
                       @click="handleLeave(scope.row)">离开</el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :total="pagination.total"
                  :pageSize="pagination.perPage"
                  @handleSizeChange="handleSizeChange"
                  @handleCurrent="handleCurrentChange"></Pagination>
    </el-card>
    <VisitorAdd v-if="showVisitorAdd"
                :isShow="showVisitorAdd"
                :areaList="areaList"
                :depList="depList"
                @handleClose="closeVisitorAdd">
    </VisitorAdd>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import mediumApi from '@/common/medium'
import VisitorAdd from '@/views/humanResources/visitor/VisitorAdd'
import Pagination from '@/components/pagination/Pagination'

export default {
  components: { VisitorAdd, Pagination },
  data() {
    return {
      activeName: 'cur',
      countDown: false,
      timer: 45,
      timeObj: null,
      randomNum: '',
      authId: localStorage.getItem('token'),
      areaList: [],
      depList: [],
      searchForm: {
        vist_name: '',
        med_value: '',
        inter_name: '',
        inter_dep_id: '',
        inter_area_id: '',
        begin_time: []
      },
      tableTitle: [
        {
          prop: 'vist_name',
          name: '访客姓名',
          width: '100'
        },
        {
          prop: 'vist_sex',
          name: '访客性别',
          width: '100'
        },
        {
          prop: 'vist_birthday',
          name: '访客出生日期',
          width: '120'
        },
        {
          prop: 'vist_id_no',
          name: '访客身份证号',
          width: '120'
        },
        {
          prop: 'vist_address',
          name: '访客籍贯地址',
          width: '160'
        },
        {
          prop: 'vist_contex',
          name: '访客联系方式',
          width: '120'
        },
        {
          prop: 'vist_car_no',
          name: '访客车牌号码',
          width: '120'
        },
        {
          prop: 'vist_people_count',
          name: '同行人数',
          width: '100'
        },
        {
          prop: 'vist_cause',
          name: '来访事由',
          width: '160'
        },
        {
          prop: 'vist_goods',
          name: '携带物品',
          width: '160'
        },
        {
          prop: 'vist_begin_time',
          name: '访问开始时间',
          width: '160'
        },
        {
          prop: 'vist_leave_time',
          name: '访问结束时间',
          width: '160'
        },
        {
          prop: 'med_value',
          name: '访客卡号',
          width: '100'
        },
        {
          prop: 'inter_name',
          name: '被访人姓名',
          width: '100'
        },
        {
          prop: 'inter_sex',
          name: '被放人性别',
          width: '100'
        },
        {
          prop: 'inter_dep_name',
          name: '被访人部门',
          width: '160'
        },
        {
          prop: 'inter_contex',
          name: '被访人电话',
          width: '120'
        },
        {
          prop: 'inter_area_name',
          name: '访问区域（楼层）',
          width: '160'
        },
        {
          prop: 'inter_lock_name',
          name: '访问房间',
          width: '160'
        },
        {
          prop: 'remark',
          name: '备注',
          width: '160'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 新增入住
      showVisitorAdd: false
    }
  },
  created() {
    this.getList()
    this.getAreaTree()
    this.getDepTree()
  },
  methods: {
    //读取ic卡号
    readIC() {
      // loading倒计时提醒
      this.countDown = true
      this.timeObj = setInterval(() => {
        if (this.timer > 0) {
          this.timer--
        }
        if (this.timer === 0) {
          this.countDown = false
          clearInterval(this.timeObj)
        }
      }, 1000)
      this.randomNum = this.getRandomNum()
      mediumApi
        .getMediumInfo(
          {
            medType: 'ic',
            medTag: this.randomNum
          },
          { timeout: 45000 }
        )
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              if (data.medType === 'ic' && data.medTag === this.randomNum) {
                this.randomNum = ''
                this.searchForm.med_value = data.medValue
                this.$message.success('读取成功')
              }
              this.countDown = false
              clearInterval(this.timeObj)
            },
            (err) => {
              this.countDown = false
              clearInterval(this.timeObj)
              this.$message.error(err)
            }
          )
        })
    },
    getRandomNum() {
      let randomNum = new Date().getTime() + ''
      let tmpLen = randomNum.length
      let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      let maxPos = $chars.length
      for (var i = 0; i < 32 - tmpLen; i++) {
        randomNum += $chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return randomNum
    },
    //选项卡切换
    handleClick() {
      this.getList()
    },

    // 获取列表
    getList() {
      const { perPage, currentPage } = this.pagination
      const { searchForm } = this

      let datas = {
        vist_name: searchForm.vist_name,
        med_value: searchForm.med_value,
        inter_name: searchForm.inter_name,
        inter_dep_id: searchForm.inter_dep_id,
        inter_area_id: searchForm.inter_area_id,
        startTime: searchForm.begin_time.length ? searchForm.begin_time[0] : '',
        endTime: searchForm.begin_time.length ? searchForm.begin_time[1] : ''
      }
      fetch
        .getVisitorList({
          type: this.activeName,
          perPage: perPage,
          currentPage: currentPage,
          ...datas
        })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list.map((item) => {
                item.vist_sex = item.vist_sex === '1' ? '男' : item.vist_sex === '2' ? '女' : '未知'
                return item
              })
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },

    //  格式化名称
    titleFormat(data, prefix) {
      if (data.length === 0) {
        return []
      }
      data.forEach((item) => {
        let tmp = item
        tmp.name = prefix + item.name
        this.tmpArr.push(tmp)
        if (item.children && item.children.length > 0) {
          this.titleFormat(item.children, '• ' + prefix)
        }
      })
      return this.tmpArr
    },
    // 获取区域数据
    getAreaTree() {
      fetch.getAreaTree({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.tmpArr = []
            this.areaList = this.titleFormat(data.treeData, '• ')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 获取部门数据
    getDepTree() {
      fetch.getDepartmentTree({}).then((data) => {
        data.procData(
          data.res,
          (data) => {
            this.tmpArr = []
            this.depList = this.titleFormat(data.treeData, '• ')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    },
    // 搜索提交
    searchSubmit() {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.getList()
    },
    resetForm(formName) {
      this.pagination.perPage = 10
      this.pagination.currentPage = 1
      this.searchForm.begin_time = []
      this.$refs[formName].resetFields()
      this.getList()
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },

    // 新增访客
    openVisitorAdd() {
      this.showVisitorAdd = true
    },
    // 关闭入住
    closeVisitorAdd(type) {
      if (type === 'refresh') {
        this.getList()
      }
      this.showVisitorAdd = false
    },

    // 访客离开
    handleLeave(data) {
      this.$confirm('此访客已换取质押证件并离开?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          fetch.visitorLeave({ id: data.id }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.getList()
                this.$message.success('操作成功')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style></style>
